export const DomainStatus = Object.freeze({
    ACTIVE: 'active',
    CONNECTING: 'connecting',
    WAITING: 'waiting',
    NOT_CONNECTED: 'not_connected',
    INACTIVE: 'inactive',
    OLD_SERVER: 'old_server'
  });

export const RecordStatus =  Object.freeze({
    CONNECTED: 'connected',
    CONNECTING: 'connecting',
    NOT_CONNECTED: 'not_connected',
    INACTIVE: 'inactive',
    OLD_SERVER: 'old_server',
    TESTING: 'testing'
});

export const SectionTypesEnum = Object.freeze({
    HERO:"Hero",
    NAVIGATION:"Navigation",
    MAIN_HEADER:"MainHeader",
    HEADER:"Header",
    TEXT:"Text",
    ACCORDION:"Accordion",
    ANIMATED_TEXT:"AnimatedText",
    MEDIA:"Media",
    TEXT_AND_MEDIA:"TextAndMedia",
    GENERAL:"General",
    PROCESS:"Process",
    STAT:"Stat",
    GALLERY:"Gallery",
    TABS:"Tabs",
    COLUMNS:"Columns",
    CARDS:"Cards",
    CONTACT_FORM:"ContactForm",
    CASE_STUDY_GRID:"ProjectGrid",
    CTA:"Cta",
    TESTIMONIAL:"Testimonial",
    LOGO_WALL:"LogoWall",
    DIVIDER_LINE:"DividerLine",
    ADPLIST_PROFILE:"ADPList",
    FOOTER:"PortfolioFooter",
    RELATED_CASE_STUDIES_FOOTER:"RelatedCaseStudyFooter"
});

export const SectionTypeLabelEnum = Object.freeze({
    [SectionTypesEnum.HERO]: "Hero",
    [SectionTypesEnum.NAVIGATION]: "Navigation",
    [SectionTypesEnum.MAIN_HEADER]: "Hero",
    [SectionTypesEnum.HEADER]: "Subheader",
    [SectionTypesEnum.TEXT]: "Text",
    [SectionTypesEnum.ACCORDION]: "Accordions",
    [SectionTypesEnum.ANIMATED_TEXT]: "Text carousel",
    [SectionTypesEnum.MEDIA]: "Media",
    [SectionTypesEnum.TEXT_AND_MEDIA]: "Text & image",
    [SectionTypesEnum.GENERAL]: "Content",
    [SectionTypesEnum.PROCESS]: "Process",
    [SectionTypesEnum.STAT]: "Stats",
    [SectionTypesEnum.GALLERY]: "Gallery",
    [SectionTypesEnum.TABS]: "Tabs",
    [SectionTypesEnum.COLUMNS]: "Columns",
    [SectionTypesEnum.CARDS]: "Cards",
    [SectionTypesEnum.CONTACT_FORM]: "Contact form",
    [SectionTypesEnum.CASE_STUDY_GRID]: "Case study grid",
    [SectionTypesEnum.CTA]: "Call to action",
    [SectionTypesEnum.TESTIMONIAL]: "Testimonials",
    [SectionTypesEnum.LOGO_WALL]: "Logos",
    [SectionTypesEnum.DIVIDER_LINE]: "Divider line",
    [SectionTypesEnum.ADPLIST_PROFILE]: "ADPList",
    [SectionTypesEnum.FOOTER]: "Footer",
    [SectionTypesEnum.RELATED_CASE_STUDIES_FOOTER]: "Related case studies footer",
});

export const SectionModuleTypeEnum = Object.freeze({
    TITLE:"TITLE",
    TEXT:"TEXT",
    ACCORDION:"ACCORDION",
    MEDIA:"MEDIA",
    CTA:"CTA",
    COLUMN:"COLUMN",
    CONTACT_FORM:"CONTACT_FORM",
    SPACER:"SPACER",
    PROJECT_GRID:"PROJECT_GRID",
    TESTIMONIAL:"TESTIMONIAL",
    STAT_ITEM:"STAT_ITEM",
    PROCESS_ITEM:"PROCESS_ITEM",
    MOCKUP_LAYOUT:"MOCKUP_LAYOUT"
})
export const SectionMediaTypesEnum = Object.freeze({
    IMAGE:"Image",
    VIDEO:"Video",
    PROTOTYPE:"Prototype",
    MEDIA:"Media",
    ADPLIST:"ADPList",
    MOCKUP:"Mockup"
});

export const MockupDisplayModeEnum = Object.freeze({
    DEVICE: "DEVICE",
    LAYOUT: "LAYOUT"
});

export const SectionSuggestionTypesEnum = Object.freeze({
    BOLD_STATEMENT:"BoldStatement"
});

export const CardLayoutEnum = Object.freeze({
    ROW_2: "row-2",
    ROW_3: "row-3",
    GRID_2X2: "grid-2x2",
    GRID_3X2: "grid-3x2"
});

export const PresetPlacementTargetEnum = Object.freeze({
    PORTFOLIO: "PORTFOLIO",
    CASE_STUDY: "CASE_STUDY",
});

export const GeneralSectionTypeEnum = Object.freeze({
    GENERAL: SectionTypesEnum.GENERAL,
    HEADER: SectionTypesEnum.HEADER,
    TEXT:SectionTypesEnum.TEXT,
    ACCORDION:SectionTypesEnum.ACCORDION,
    MEDIA:SectionTypesEnum.MEDIA,
    TEXT_AND_MEDIA:SectionTypesEnum.TEXT_AND_MEDIA,
    CONTACT_FORM:SectionTypesEnum.CONTACT_FORM,
    CTA:SectionTypesEnum.CTA,
    // TESTIMONIAL:SectionTypesEnum.TESTIMONIAL,
});

export const EditedImageTypeEnum = Object.freeze({
    IMAGE:"image",
    MEDIA:"media",
    GALLERY_ITEMS: "galleryItems",
    LOGOS: "logos",
    PORTFOLIO_HERO_IMAGE: "portfolioHeroImage",
    PORTFOLIO_HERO_MEDIA: "portfolioHeroMedia",
    PORTFOLIO_LOGO: "portfolioLogo",
    THUMBNAIL: "thumbnail",
    THUMBNAIL_DESIGNER: 'thumbnail_designer'
});

export const FileUploadTypeEnum = Object.freeze({
    IMAGE: "image",
    IMAGES: "images",
    LOGO: "logo",
    RESUME: "resume",
    FAVICON: "favicon",
    THUMBNAIL: "thumbnail",
    THUMBNAIL_IMAGE: "thumbnailImage",
});

export const DesignPanelTypesEnum = Object.freeze({
    MAIN_PANEL:"main-panel",
    TEMPLATES:"templates",
    COLORS:"colors",
    COLOR_PALETTES:"color-palettes", // New
    FONTS:"fonts", // New
    ADVANCED_HEADING_STYLE_SETTINGS: "headings",
    ADVANCED_PARAGRAPH_STYLE_SETTINGS: "paragraphs",
    ADVANCED_NAVIGATION_STYLE_SETTINGS: "navigation-buttons",
    ADVANCED_BUTTON_STYLE_SETTINGS: "buttons",
    ADVANCED_HEADING_COLOR_SETTINGS: "heading-colors",
    ADVANCED_PARAGRAPH_COLOR_SETTINGS: "paragraph-colors",
    ADVANCED_NAVIGATION_COLOR_SETTINGS: "navigation-colors",
    ADVANCED_BUTTON_COLOR_SETTINGS: "button-colors",
    ADVANCED_LABEL_COLOR_SETTINGS: "label-colors",
    ADVANCED_SOCIAL_ICON_COLOR_SETTINGS: "social-icon-colors",
    ADVANCED_CONTACT_FORM_COLOR_SETTINGS: "contact-form-colors",
    ADVANCED_PROCESS_STEP_COLOR_SETTINGS: "process-step-colors",
    ADVANCED_BACKGROUND_COLOR_SETTINGS: "backgrounds",
    EDIT_COLOR_PALETTE: "edit-color-palette",
    PALETTE_DESIGNER: "palette-designer",
    BUTTONS:"buttons",
    CURSORS:"cursors",
    LABELS:"labels",
    SOCIAL_ICON_SETTINGS: "social-icon-settings",
    ADVANCED_BUTTON_SETTINGS: "advanced-button-settings",
    SPACING:"spacing",
    SITE_MARGIN:"site-margin",
    DISPLAY_OPTIONS:"display-options",
    ANIMATION_SETTINGS:"animation-settings",
    RESET:"reset"
});

export const DesignPanelPathsEnum = Object.freeze({
    ROOT:"style",
    CHANGE_TEMPLATE:"change-template",
    COLORS:"colors",
    COLOR_PALETTES:"color-palettes",
    FONTS:"fonts",
    ADVANCED_HEADING_STYLE_SETTINGS: "headings",
    ADVANCED_PARAGRAPH_STYLE_SETTINGS: "paragraphs",
    ADVANCED_NAVIGATION_STYLE_SETTINGS: "navigation-buttons",
    ADVANCED_BUTTON_FONT_SETTINGS: "buttons",
    ADVANCED_HEADING_COLOR_SETTINGS: "heading-colors",
    ADVANCED_PARAGRAPH_COLOR_SETTINGS: "paragraph-colors",
    ADVANCED_NAVIGATION_COLOR_SETTINGS: "navigation-colors",
    ADVANCED_BUTTON_COLOR_SETTINGS: "button-colors",
    ADVANCED_LABEL_COLOR_SETTINGS: "label-colors",
    ADVANCED_SOCIAL_ICON_COLOR_SETTINGS: "social-icon-colors",
    ADVANCED_CONTACT_FORM_COLOR_SETTINGS: "contact-form-colors",
    ADVANCED_PROCESS_STEP_COLOR_SETTINGS: "process-step-colors",
    ADVANCED_BACKGROUND_COLOR_SETTINGS: "backgrounds",
    EDIT_COLOR_PALETTE: "edit-color-palette",
    PALETTE_DESIGNER: "palette-designer",
    BUTTON_SETTINGS:"button-settings",
    CURSOR_SETTINGS:"cursor-settings",
    LABEL_SETTINGS:"label-settings",
    SOCIAL_ICON_SETTINGS: "social-icon-settings",
    ADVANCED_BUTTON_SETTINGS: "advanced-button-settings",
    SPACING:"spacing",
    SITE_MARGIN:"site-margin"
});

export const SettingsPanelTypesEnum = Object.freeze({
    MAIN_PANEL:"main-panel",
    SHARE:"share",
    DOMAIN:"own-domain",
    DOMAIN_AND_URL:"domain-and-url",
    SOCIAL_MEDIA_LINKS:"social-media-links",
    ADD_SOCIAL_LINKS:"add-social-links",
    EDIT_SOCIAL_LINKS:"edit-social-links",
    PORTFOLIO_LOGO:"portfolio-logo",
    FAVICON:"favicon",
    PASSWORD:"password",
    ARCHIVE:"archive",
    FOOTER:"portfolio-footer",
    URL:"url-slug",
    HIDE_FROM_SEARCH:"hide-from-search-engines",
    THUMBNAIL_SETTINGS:"thumbnail-settings",
    NAVIGATION:"navigation",
    BANNER:"banner"
});

export const SettingsPanelPathsEnum = Object.freeze({
    ROOT:"settings",
    SHARE:"share",
    DOMAIN_AND_URL:"domain-and-url",
    SOCIAL_MEDIA_LINKS:"social-media-links",
    ADD_SOCIAL_LINK:"add-social-link",
    EDIT_SOCIAL_LINK:"edit-social-link",
    PORTFOLIO_LOGO:"portfolio-logo",
    FAVICON:"favicon",
    PASSWORD:"password",
    ARCHIVE:"archive",
    THUMBNAIL_SETTINGS:"basic-details",
    NAVIGATION:"display-options",
    URL:"url-slug",
})

export const PagesPanelTypesEnum = Object.freeze({
    MAIN_PANEL:"main-panel",
    ADD_NEW_PAGE:"add-new-page",
    NAVIGATION_EXTERNAL_LINK:"external-link",
    NAVIGATION_MAILTO_LINK:"mailto-link",
    RESUME:"resume",
})

export const PagesPanelPathsEnum = Object.freeze({
    ROOT:"pages",
    ADD_NEW_PAGE:"add-new-page",
    NAVIGATION_EXTERNAL_LINK:"external-link",
    NAVIGATION_MAILTO_LINK:"mailto-link",
    RESUME:"resume",
})

export const SectionSettingTypesEnum = Object.freeze({
    BACKGROUND: "background",
    ADD_MEDIA: "add-media",
    ACCORDION: "accordion",
    ANIMATED_TEXT: "animated-text",
    CASE_STUDY_GRID: "case-study-grid",
    DIVIDER_LINES: "divider-lines",
    LOGO_WALL: "logo-wall",
    GENERAL: "general",
    COLUMNS: "columns",
    HEADER: "header",
    CTA: "cta",
    GALLERY: "gallery",
    TABS: "tabs",
    LEGACY_HERO: "hero",
    HERO: "portfolio-hero",
    FOOTER:"footer",
    RELATED_CASE_STUDIES_FOOTER: "related-case-studies-footer",
    CARDS: "cards",
    TESTIMONIAL: "testimonial",
    NAVIGATION: "navigation",
    PORTFOLIO_LOGO: "portfolio-logo"
})

export const HeroLayoutTypeEnum = Object.freeze({
    MODULAR: "Modular",
    OVERLAY: "Overlay",
    SIDEBAR: "Sidebar",
})

export const SidebarBackgroundStyleEnum = Object.freeze({
    FILLED: "Filled",
    OUTLINED: "Outlined",
})

export const HeroContentFlowEnum = Object.freeze({
    HORIZONTAL: "Horizontal",
    VERTICAL: "Vertical",
})

export const PageTypesEnum = Object.freeze({
    HOME:"home",
    ABOUT:"about",
    CONTACT:"contact",
    BLANK:"blank",
    LINK:"link",
    MAILTO:"mailto",
    FILE:"file",
    CASE_STUDY:"caseStudy"
});

export const CtaTypesEnum = Object.freeze({
    PRIMARY:"primary",
    SECONDARY:"secondary",
})

//Didivder line
export const DividerLineTextPositionEnum = Object.freeze({
    BELOW:"below",
    ABOVE:"above",
    IN_LINE:"in_line",
    NO_TEXT:"no_text",
});
export const DividerLineWeightEnum = Object.freeze({
    LIGHT:"weight-light",
    MEDIUM:"weight-medium",
    BOLD:"weight-bold",
});

// Navigation properties
export const NavigationTypeEnum = Object.freeze({
    ABOVE:"above", // above the hero content
    BELOW:"below", // below the hero content
    INLINE_BELOW_TEXT:"inline-below-text" // inside the hero content, under the text
})

export const NavigationPlacementEnum = Object.freeze({
    TOP:"Top",
    BOTTOM:"Bottom",
    UNDER_TEXT:"UnderText"
})

export const NavigationLayoutEnum = Object.freeze({
    SIDES:"sides", // name or logo in the left, menu on the right
    MIDDLE:"middle", // user image in the middle, menu is split to left and right (Axis)
    SIMPLE_LEFT:"simple-left",
    SIMPLE_MIDDLE:"simple-middle",
    SIMPLE_RIGHT:"simple-right",
    LINE_MIDDLE:"line-middle"
})

export const NavigationLayoutTypeEnum = Object.freeze({
    SIMPLE:"Simple",
    SIMPLE_WITH_LOGO:"SimpleWithLogo",
    SIDES:"Sides",
    SIDES_WITH_CTA:"SidesWithCta",
    CENTERED:"Centered",
    SPLIT_NAVIGATION:"SplitNavigation",
    SPLIT_LOGO:"SplitLogo",
    SIDEBAR:"Sidebar"
})

export const NavigationAlignmentEnum = Object.freeze({
    LEFT:"Left",
    CENTER:"Center",
    RIGHT:"Right"
})

export const NavigationMenuItemAlignmentEnum = Object.freeze({
    VERTICAL:"Vertical",
    HORIZONTAL:"Horizontal"
})

export const NavigationSidebarPlacementEnum = Object.freeze({
    TOP:"Top",
    BOTTOM:"Bottom",
    OUTSIDE:"Outside"
})

export const NavigationStyleEnum = Object.freeze({
    SIMPLE:"simple",
    FORWARD_SLASH:"forward_slash"
})

export const NavigationVisualStyleEnum = Object.freeze({
    SIMPLE:"Simple",
    FRAMED:"Framed",
    FORWARD_SLASH:"ForwardSlash",
    LINE_BOTH_SIDES:"LineBothSides"
})

export const NavigationFrameLayoutEnum = Object.freeze({
    FULL_WIDTH:"FullWidth",
    CENTERED:"Centered",
})

export const NavigationButtonStyleEnum = Object.freeze({
    REGULAR:"regular",
    BOLD:"bold",
    UNDERLINE_REGULAR:"underline-regular",
    UNDERLINE_SMALL:"underline-small",
    UNDERLINE_LARGE:"underline-large",
    BOX_SHARP: "box-sharp",
    BOX_ROUNDED: "box-rounded",
    BOX_PILL: "box-pill",
    BOX_PILL_FILL: "box-pill-fill",
})

export const NavigationMenuStyleEnum = Object.freeze({
    SIMPLE:"Simple",
    UNDERLINED:"Underlined",
    FRAMED:"Framed",
})

export const NavigationUnderlineSizeEnum = Object.freeze({
    SHORT:"Short",
    FULL_WIDTH:"FullWidth",
})

export const NavigationUnderlineWeightEnum = Object.freeze({
    LIGHT:"Light",
    MEDIUM:"Medium",
    BOLD:"Bold",
})

export const NavigationBoxShapeEnum = Object.freeze({
    SHARP:"Sharp",
    ROUNDED:"Rounded",
    PILLED:"Pilled",
})

export const NavigationBoxWeightEnum = Object.freeze({
    FILLED:"Filled",
    OUTLINED:"Outlined",
})

export const NavigationScrollEffectEnum = Object.freeze({
    SCROLL_WITH_PAGE:"ScrollWithPage",
    STAY_ON_TOP:"StayOnTop",
    ANIMATE_OUT_AND_BACK:"AnimateOutAndBack",
})

export const NavigationLinkHoverEffectEnum = Object.freeze({
    COLOR:"Color",
    UNDERLINE:"Underline",
    FLIP_TEXT:"FlipText",
})

export const SocialLinksLocationEnum = Object.freeze({
    NAVBAR:"in-navbar", // displaying inside the navbar where it appears
    INLINE_ABOVE_TEXT:"inline-above-text", // inside the hero or sidebar content, above the text
    INLINE_BELOW_TEXT:"inline-below-text", // inside the hero or sidebar content, below the text
    INLINE_STICK_TO_BOTTOM:"inline-stick-to-bottom", //inside the hero, Nelson template
    OFF_GRID:"off-grid" // outside of hero or navbar on a fucked up place, Poster template early versions
})

export const SocialLinksPlacementEnum = Object.freeze({
    NAVBAR:"Navbar",
    INLINE_ABOVE_TEXT:"InlineAboveText",
    INLINE_BELOW_TEXT:"InlineBelowText",
    INLINE_STICK_TO_BOTTOM:"InlineStickToBottom",
    OFF_GRID:"OffGrid"
})

export const SocialLinkTypeEnum = Object.freeze({
    ICON:"icon",
    TEXT:"text"
})

export const SocialLinkPlatformTypeEnum = Object.freeze({
    LINKEDIN: "LinkedIn",
    BEHANCE: "Behance",
    DRIBBBLE: "Dribbble",
    MEDIUM: "Medium",
    X: "X",
    INSTAGRAM: "Instagram",
    PINTEREST: "Pinterest",
    TUMBLR: "Tumblr",
    YOUTUBE: "Youtube",
    VIMEO: "Vimeo",
    SLACK: "Slack",
    GITHUB: "Github",
});

export const SocialLinkPlatformTypes = Object.freeze(Object.values(SocialLinkPlatformTypeEnum));

// TODO legacy, remove once hero and nav refactor is done, rename SocialLinkStylePascalEnum
export const SocialLinkStyleEnum = Object.freeze({
    SIMPLE:"simple",
    BOX_SHARP:"box-sharp",
    BOX_ROUNDED:"box-rounded",
    BOX_PILL:"box-pill",
    BOX_PILL_FILL:"box-pill-fill",
    UNDERLINE_REGULAR: "underline-regular"
})

// Social links used in legacy navigations
export const SocialLinkStylePascalEnum = Object.freeze({
    SIMPLE:"Simple",
    BOX_SHARP:"BoxSharp",
    BOX_ROUNDED:"BoxRounded",
    BOX_PILL:"BoxPill",
    BOX_PILL_FILL:"BoxPillFill",
    UNDERLINE_REGULAR:"UnderlineRegular",
})

export const UiItemFillTypeEnum = Object.freeze({
    FILL: "Fill",
    OUTLINE: "Outline",
})

export const UiItemCornerRadiusValues = Object.freeze([0, 8, 999]);
export const UiItemStrokeWeightValues = Object.freeze([1, 2, 4]);
export const UiItemCornerRadiusDefault = 8;
export const UiItemStrokeWeightDefault = 1;

export const SocialLinkWeight = Object.freeze({
    OUTLINED:"outlined",
    FILLED:"filled"
})

export const ReviewTypeEnum = Object.freeze({
    PORTFOLIO:'Portfolio',
    CASE_STUDY:'CaseStudy'
})

export const SuggestedColorsEnum = Object.freeze({
    SUBTLE:"subtle",
    PLATFORM:"platform",
    ACCENT:"accent",
    ACCENT_PLATFORM:"accent_platform",
    CONTRAST:"contrast"
})


export const ChecklistInteractionEnum = Object.freeze({
    TEMPLATE:"template",
    CUSTOMIZE:"customize",
    HEADLINE:"headline",
    CASE_STUDY:"caseStudy",
    THUMBNAIL:"thumbnail",
    LAYOUT:"layout", //Unused
    RESUME:"resume", //Unused
    DOMAIN:"domain", //Unused
    PUBLISH:"publish"
})


export const ReviewStateEnum = Object.freeze({
    EMPTY:"Empty",
    INCOMPLETE:"Incomplete",
    FINISHED:"Finished",
})

export const ReviewLoginModalStateEnum = Object.freeze({
    GUEST:"guest",
    GUEST_CONTINUE:"guest_continue",
    EXISTING_USER:"existing_user",
    AUTH_ERROR:"auth_error",
    LOGIN_ERROR:"login_error",
    FOLLOW_UP:"follow_up"
})

export const ReviewCommentsFilterEnum = Object.freeze({
    ALL_CATEGORIES:"All Categories",
    DESIGN:"Design",
    CONTENT:"Content",
    STRUCTURE:"Structure",
    IMAGERy:"Imagery",
})

export const SubscriptionPlanType = Object.freeze({
    FREE: "Free",
    TRIAL: "Trial",
    PREMIUM: "Premium",
    STANDARD: "Standard",
    VIP: "VIP"
})

export const Features = Object.freeze({
    PUBLISH_PORTFOLIO: "publish-portfolio",
    PUBLISH_CASE_STUDY: "publish-case-study",
    EDIT_FONTS: "edit-fonts",
    EDIT_COLORS: "edit-colors",
    EDIT_ANIMATIONS: "edit-animations",
    COLLECT_REVIEWS: "collect-reviews",
    CUSTOM_DOMAIN: "custom-domain",
    ANALYTICS: "analytics",
    PASSWORD_PROTECTION: "password-protection",
    SHARE_LINK: "share-link",
    HIDE_BANNER: "hide-banner"
})

export const FreeFeatureList = Object.freeze([
    Features.ANALYTICS,
    Features.EDIT_FONTS,
    Features.EDIT_COLORS,
    Features.EDIT_ANIMATIONS
])

export const TrialFeatureList = Object.freeze([
    Features.EDIT_FONTS,
    Features.EDIT_COLORS,
    Features.EDIT_ANIMATIONS,
])

export const PremiumFeatureList = Object.freeze([
    Features.PUBLISH_PORTFOLIO,
    Features.PUBLISH_CASE_STUDY,
    Features.EDIT_FONTS,
    Features.EDIT_COLORS,
    Features.EDIT_ANIMATIONS,
    Features.COLLECT_REVIEWS,
    Features.CUSTOM_DOMAIN,
    Features.ANALYTICS,
    Features.PASSWORD_PROTECTION,
    Features.SHARE_LINK,
    Features.HIDE_BANNER
])

export const AiFeatures = Object.freeze({
    CASE_STUDY_GENERATOR: "CASE_STUDY_GENERATOR",
    TEXT_ENHANCER: "TEXT_ENHANCER",
    CUSTOM_PROMPT: "CUSTOM_PROMPT",
    JOB_FIT_CHECKER: "JOB_FIT_CHECKER",
    SOURCE_BUNDLE_AGENT: "SOURCE_BUNDLE_AGENT",
    FIGMA_VISUAL_SELECTOR: "FIGMA_VISUAL_SELECTOR",
    CONTENT_REFINEMENT: "CONTENT_REFINEMENT",
})

export const PollJobStatus = Object.freeze({
    SUBMITTED: "SUBMITTED",
    PROCESSING: "PROCESSING",
    COMPLETED: "COMPLETED",
    NOT_FOUND: "NOT_FOUND",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED",
})

export const TemplateStatus = Object.freeze({
    DRAFT: "DRAFT",
    PUBLISHED: "PUBLISHED"
})

export const TextEnhanceOptions = {
    SHORTEN: "MAKE_SHORTER",
    FIX_GRAMMAR: "FIX_GRAMMAR_AND_TYPOS",
    BOOST_STORY:"BOOST_STORYTELLING",
    IMPROVE_WRITING:"IMPROVE_WRITING",
    CUSTOM_PROMPT:"CUSTOM_PROMPT",
    MAKE_IT_STAND_OUT:"MAKE_IT_STAND_OUT"
};

export const ModalTopNotificationType = Object.freeze({
    INFO: "info",
    WARNING: "warning",
    SUCCESS: "success",
})


export const ResizeDirections = Object.freeze({
    HORIZONTAL: "HORIZONTAL",
    VERTICAL: "VERTICAL",
    ALL: "ALL",
    SINGLE: "SINGLE"
})

export const UpgradePromptType = Object.freeze({
    DOMAIN: "domain",
    PASSWORD: "password"
})

export const FooterCornerRadiusMap = Object.freeze({
    0: 0,
    8: 4,
    12: 8,
    16: 12,
    24: 16,
    32: 24,
})

export const BackgroundLibraryScope =  Object.freeze({
    THUMBNAILS:"THUMBNAILS"
})

export const HeroBackgroundRendererKey = Object.freeze({
    AURORA: "AURORA",
    LIGHT_RAYS: "LIGHT_RAYS",
    BEAMS: "BEAMS",
    THREADS: "THREADS",
    LINE_WAVES: "LINE_WAVES",
    PARTICLES: "PARTICLES",
    DOT_GRID: "DOT_GRID",
    SQUARES: "SQUARES",
    PIXEL_BLAST: "PIXEL_BLAST",
    GRADIENT: "GRADIENT",
    GRADIENT_BLINDS: "GRADIENT_BLINDS",
    SILK: "SILK"
})

export const BackgroundTypeEnum = Object.freeze({
    NONE: "none",
    SOLID: "solid",
    ANIMATED: "animated",
    IMAGE: "image",
    GRADIENT: "gradient"
})


export const ThumbnailBackgroundStyle =  Object.freeze({
    CURATED_BACKGROUNDS:"curated_backgrounds",
    UPLOAD_IMAGE:"upload_image",
    GRADIENT:"gradient",
    SOLID_COLOR:"solid_color",
    TRANSPARENT:"transparent"
})

export const ListItemTypeEnum = Object.freeze({
    BASIC:"basic",
    ADD_MEDIA:"add-media",
})

export const CaseStudyCardSizeEnum = Object.freeze({
    SMALL:"Small",
    MEDIUM:"Medium",
})

export const CursorAlternatives = Object.freeze({
    DEFAULT:"Default",
    CIRCLE:"Circle",
    ARROW:"Arrow",
    LABELED:"Labeled",
    BLURRED:"Blurred",
    FIGMA:"Figma",
    EMOJI:"Emoji"
})

export const GalleryLayout = Object.freeze({
    GRID:"Grid",
    OFFSET_GRID:"OffsetGrid",
    CAROUSEL:"Carousel",
    SLIDER:"Slider",
    TILTED:"Tilted"
})

export const GalleryControlsPosition = Object.freeze({
    SIDES:"Sides",
    BOTTOM:"Bottom"
})
